module.exports = __webpack_public_path__ + "img/icons8-users-96 (1).2a0b7fe1.png";